export type SelectOption = { value: string; label: string };
type OptionLike = { value: string; label: string };

export function toOptions(values: string[]): SelectOption[] {
  return (values || []).map((value) => ({ value, label: value }));
}

export function toMultiValue(values?: string[]): SelectOption[] {
  return (values || []).map((value) => ({ value, label: value }));
}

export function toValue(value?: string): SelectOption | null {
  return value ? { value, label: value } : null;
}

export function toValueFromOptions<T extends OptionLike>(
  options: T[],
  value?: string,
  labelByValue: Record<string, string> = {},
): SelectOption | null {
  if (!value) return null;
  const byValue = new Map(options.map((option) => [option.value, option]));
  const option = byValue.get(value);
  return option ? { value: option.value, label: option.label } : { value, label: labelByValue[value] || value };
}
